import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {User} from 'nutshell-core/types';

import {EngagementSidebar} from '../../ui/engagement/engagement-sidebar';
import {INBOX_SEARCH} from '../../ui/inbox/inbox-page';
import {DASHBOARD} from '../../ui/reports/report-types';

import {UrlParamsWrapper} from '../utils';

type EngagementSidebarWrapperProps = ContextRouter & {
    user: User | null | undefined;
    isEmbedded: boolean;
};

export function EngagementSidebarWrapper({
    user,
    isEmbedded,
    ...props
}: EngagementSidebarWrapperProps) {
    return (
        <UrlParamsWrapper routeProps={props} reportKey={DASHBOARD} localStorageKey={INBOX_SEARCH}>
            {(urlParamsProps) => (
                <EngagementSidebar
                    {...urlParamsProps}
                    {...props}
                    user={user}
                    isSessionUserLoading={!user}
                    isEmbedded={isEmbedded}
                />
            )}
        </UrlParamsWrapper>
    );
}
